module.exports = "../../app/cells/components/directed_sheet_news_cell.rb";